export interface AccountData {
  account_type: string;
  bookmarks: any[];
  cover_photo_url: any;
  email: string;
  name: string;
  petition: any[];
  photo_url: any;
  post: any[];
  replies: any[];
}
export const DummyAccountData = {
  account_type: "citizen",
  bookmarks: [],
  cover_photo_url: "",
  email: "",
  name: "",
  petition: [],
  photo_url: "",
  post: [],
  replies: [],
};

export interface AccountProfileData {
  id: number;
  account_type: string;
  photo_url: string;
  cover_photo_url: any;
  name: string;
  phone_number: any;
  email: string;
  gender: string;
  dob: string;
  state: string;
  local_government: string;
  polling_unit: any;
  created_at: string;
}

export const DummyAccountProfileData: AccountProfileData = {
  id: 0,
  account_type: "",
  photo_url: "",
  cover_photo_url: "",
  name: "",
  phone_number: "",
  email: "",
  gender: "",
  dob: "",
  state: "",
  local_government: "",
  polling_unit: "",
  created_at: "",
};

export interface TextHeaderProps {
  header: string;
  text: string;
  onPress: () => void;
}
export interface TextHeaderInputProps {
  header: string;
  value: string;
  changeValue: any;
}

export interface PetitonPropsData {
  author: string;
  author_badge: number;
  author_photo_url: string;
  bookmarks: number;
  comments: number;
  context: string;
  created_at: string;
  id: number;
  likes: number;
  media: any[];
  post_type: string;
  reposts: number;
  title: string;
}

export interface ReplyDataProps {
  author_id: number;
  author_name: string;
  author_photo_url: string;
  comment: string;
  comment_id: number;
  commented_entity: {
    author_id: number;
    author_name: string;
    author_photo_url: string;
    created_at: string;
    context: string;
    id: number;
    title: string;
    type: string;
  };
}

export interface ReportContainerPropsType {
  media: any;
  author: string;
  author_badge: number;
  author_account_type: number;
  author_id: number;
  author_photo_url: string;
  context: string;
  account: string;
  title: string;
  source: string;
  badge: number;
  id: number;
  created_at: string;
  comments: number;
  likes: number;
  reposts: number;
  current_user_bookmarked: boolean;
  current_user_liked: boolean;
  current_user_reposted: boolean;
  post_source: string;
  post_status: string;
  post_type: string;
  target_representatives: any[];
  target_signatures: number;
  signatures: number;
}
